import { HIDE, SHOW } from '@query/shared';
import { useEffect } from 'react';
import { useAppStore } from './store.js';
import { DataGrid } from './components/DataGrid.js';
import { InputAny } from './components/InputAny.js';
import { Toolbar } from './components/Toolbar.js';

// Инициализация должна выполниться один раз, как useEffectOnce в Kotlin-версии:
// StrictMode в dev вызывает эффекты дважды, поэтому защищаемся флагом модуля.
let initStarted = false;

/**
 * Каркас приложения — перенос AppClients (AppFC.kt:68-506).
 *
 * Состояние живёт в store (см. store.ts), поэтому компонент отвечает только за
 * компоновку: панель, строка состояния и таблица.
 */
export function App() {
  const init = useAppStore((s) => s.init);
  const showNav = useAppStore((s) => s.showNav);
  const showInput = useAppStore((s) => s.showInput);
  const resultUpdate = useAppStore((s) => s.resultUpdate);
  const titleCurrent = useAppStore((s) => s.titleCurrent);
  const currentPlaceholder = useAppStore((s) => s.currentPlaceholder);
  const rowList = useAppStore((s) => s.rowList);
  const submitInput = useAppStore((s) => s.submitInput);
  const refreshRow = useAppStore((s) => s.refreshRow);
  const setResultUpdate = useAppStore((s) => s.setResultUpdate);

  useEffect(() => {
    if (initStarted) return;
    initStarted = true;
    void init();
  }, [init]);

  return (
    <>
      <Toolbar />

      <div>
        <img
          src="img/refresh.png"
          title="refresh"
          height={20}
          alt="refresh"
          onClick={() => {
            setResultUpdate('Trying to fetch... ');
            void refreshRow().then(() => setResultUpdate(''));
          }}
        />
        <span className="cl3">{resultUpdate}</span>
        <span className="title">{titleCurrent}</span>
        <span className={`oneline ${showInput}`}>
          {showInput === SHOW ? (
            <InputAny
              placeholder={currentPlaceholder}
              onSubmit={(value) => void submitInput(value)}
            />
          ) : null}
        </span>
      </div>

      <div className={`ag-theme-alpine fullscreen${showNav === HIDE ? 'WithoutMenu' : ''}`}>
        {rowList.length > 0 ? <DataGrid /> : null}
      </div>
    </>
  );
}
